import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const ArrowSort = createSvgIcon(
  <>
    <rect width="24" height="24" fill="transparent" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0328 17.1401V4H12.9672V17.1401L14.6322 15.4751L16 16.8429L12 20.8429L8 16.8429L9.36782 15.4751L11.0328 17.1401Z"
      fill="currentColor"
    />
  </>,
  "ArrowSort"
);

export default ArrowSort;
